<mat-card class="main-card" *transloco="let t; prefix: 'yodlee'">
  @if (yodlee?.error) {
    <mat-card-header>
      <mat-card-title>{{ yodlee.error }}</mat-card-title>
      <mat-card-subtitle>{{ t('fileUploadProcess') }}</mat-card-subtitle>
    </mat-card-header>
  }
  @if (canLoadYodlee) {
    <mat-card-content class="align-center">
      <!-- showing/hiding of container-fastlink (iframe) and mat-spinner handled by css -->
      <div [id]="fastlinkElementId"></div>
      <mat-spinner color="accent"></mat-spinner>
    </mat-card-content>
  }
</mat-card>
